import { api } from "../lib/api";
import type { Job } from "./bank";

export interface LatestBackup {
  filename: string;
  created_at: string;
  size_bytes: number;
}

export interface BackupStatus {
  latest: LatestBackup | null;
  stale: boolean;
  stale_after_hours: number;
  /** A state, not a bool: item 7 (S3 offsite) isn't built, so "not_configured" must
   * never be confusable with "the last upload failed" once it is. */
  offsite: string;
  /** Non-null while a run is queued or running, so a reloaded page rejoins the poll
   * rather than offering a second one. */
  running_job_id: string | null;
  restore_command: string | null;
}

export function getBackupStatus(): Promise<BackupStatus> {
  return api.get<BackupStatus>("/api/backups/status");
}

export function startBackup(): Promise<Job> {
  return api.post<Job>("/api/backups/run");
}

export function getBackupJob(jobId: string): Promise<Job> {
  return api.get<Job>(`/api/backups/jobs/${jobId}`);
}

/** Plain hrefs, not fetches: both are GETs the browser can follow, and the archive one is
 * an X-Accel-Redirect that nginx — not this app — turns into bytes. */
export function backupDownloadHref(filename: string): string {
  return `/api/backups/download/${encodeURIComponent(filename)}`;
}

/** `?company_id=` rather than the X-Company-Id header: this is a direct-navigation link,
 * and a plain browser GET can't attach a custom header. app/api/deps.py's get_company_id
 * accepts either for exactly this case. */
export function companyExportHref(companyId: string): string {
  return `/api/backups/export?company_id=${encodeURIComponent(companyId)}`;
}
